import React, { useState, useEffect } from 'react';

const ImagePreview = ({ file, onSend, onCancel, uploading }) => {
    const [previewUrl, setPreviewUrl] = useState(null);

    useEffect(() => {
        if (!file) return;
        const url = URL.createObjectURL(file);
        setPreviewUrl(url);
        return () => URL.revokeObjectURL(url);
    }, [file]);

    const fileSizeKb = file ? Math.round(file.size / 1024) : 0;

    return (
        <div className="image-preview-bar">
            <div className="image-preview-content">
                {previewUrl && (
                    <img src={previewUrl} alt="Preview" className="image-preview-thumb" />
                )}
                <div className="image-preview-info">
                    <span className="image-preview-name">{file?.name}</span>
                    <span className="image-preview-size">{fileSizeKb} KB</span>
                </div>
            </div>
            <div className="image-preview-actions">
                <button
                    className="audio-btn audio-btn--cancel"
                    onClick={onCancel}
                    disabled={uploading}
                >
                    ✕ Cancel
                </button>
                <button
                    className="audio-btn audio-btn--send"
                    onClick={onSend}
                    disabled={uploading}
                >
                    {uploading ? '⏳ Uploading...' : '➤ Send Image'}
                </button>
            </div>
        </div>
    );
};

export default ImagePreview;
